import { useEventStatistics } from "@/hooks/firestore/betting/useEventStatistics";

const useBetTracker = (
  dataType?: "INTEGER" | "COMPETITOR_ID",
  eventId?: string,
  statisticId?: string,
) => {
  const { statistics, loading } = useEventStatistics(eventId, statisticId);

  if (!loading && !statistics) {
    return null;
  }

  if (dataType === "COMPETITOR_ID") {
    return statistics?.successfulCompetitorId ?? "";
  }

  return statistics?.value ?? 0;
};

export { useBetTracker };
